import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useState } from "react";
import { AccountSettingsStore } from "../../../shared/store";
import { NavigateFunction } from "react-router-dom";
import FundingIcon from "../../../../../../images/common/funding-blue.svg";
import DownloadIcon from "../../../../../../images/activity-dashboard/download-green.svg";
import ExportIcon from "../../../../../../images/activity-dashboard/export-blue.svg";
import ScheduleIcon from "../../../../../../images/common/clock-grey.svg";
import styled from "styled-components";
import {
  AuthService,
  CustomButton,
  CustomLabel,
  FlexContainer,
  Loader,
  SapphireBlueButton,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { DashboardService } from "../../../shared/services";
import { FundingActivityModel } from "../../../shared/models";
import { FundingActivityStatus } from "../../../shared/enums";

type IProps = {
  dashboardStore: DashboardStore;
  navigate: NavigateFunction;
  merchantAccountId: string;
};

const FundingWidgetWrapper = styled(FlexContainer)`
  height: 330px;

  .funding-label-block {
    max-height: 125px;
    overflow-y: auto;
    width: 100%;
    min-height: 109px;
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.4em;
      background-color: #15283717;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgba(21, 40, 55, 0.3);
      border-radius: 10px;
    }
    > label {
    }
    label {
      font-weight: 600;
    }
    /* .funding-labels {
          > label,
          > div {
              width: 33%;
          }
      } */
    .funding-value {
      width: 105px;
      text-align: right;
      flex-shrink: 0;
    }
    .funding-date {
      width: 130px;
      flex-shrink: 0;
    }
    ${CustomButton} {
      padding: 0px 10px;
      min-width: 86px;
      width: auto;
      border-radius: 3px;
      height: 25px;
      img {
        height: 12px;
        width: 12px;
        margin-right: 8px;
      }
      label {
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
      }
    }
  }
`;

const FundingWidget: FC<IProps> = ({
  dashboardStore,
  merchantAccountId,
  navigate,
}) => {
  const [fundingWidgetData, setFundingWidgetData] =
    useState<FundingActivityModel>(new FundingActivityModel());
  const [showLoader, setLoader] = useState(false);
  useEffect(() => {
    if (!merchantAccountId) return;
    setLoader(true);
    DashboardService.getFundings(
      AuthService.authData.accountId,
      merchantAccountId
    ).subscribe({
      next: (response) => {
        setLoader(false);
        const details = FundingActivityModel.deserializeAPIModel(
          response.result
        );
        setFundingWidgetData(details);
      },
      error: () => {
        ToastService.showError("Error Occured");
      },
    });
  }, [merchantAccountId]);

  if (showLoader) return <>{new Loader(true, "", "330px").loaderComponent}</>;

  if (showLoader || !dashboardStore.customersWidgetData) {
    return <> {new Loader(true, "", "330px").loaderComponent} </>;
  }

  const getStatusStyles = (status: keyof typeof FundingActivityStatus) => {
    switch (status) {
      case FundingActivityStatus.Deposited:
        return {
          icon: DownloadIcon,
          bgColor: "#EEF7EA",
          textColor: "#579836",
        };
      case FundingActivityStatus.InTansit:
        return {
          icon: ExportIcon,
          bgColor: "#ECF0FF",
          textColor: "#6A7AB5",
        };
      case FundingActivityStatus.Scheduled:
        return {
          icon: ScheduleIcon,
          bgColor: "#EEEEEE",
          textColor: "#555555 ",
        };
      default:
        return {
          icon: DownloadIcon,
          bgColor: "#ffebee",
          textColor: "#c62828",
        };
    }
  };

  if (!fundingWidgetData) return null;

  function payOutsSection() {
    if (!fundingWidgetData.payouts || fundingWidgetData.payouts.length === 0)
      return null;
    // const limitedPayouts = fundingWidgetData.payouts.slice(0, 3);
    return (
      <FlexContainer fxLayout="column" spacing={20}>
        <CustomLabel>Payouts</CustomLabel>
        <div className="funding-label-block">
          <FlexContainer fxLayout="column" spacing={10}>
            {fundingWidgetData.payouts.map((item, index) => {
              const { icon, bgColor, textColor } = getStatusStyles(item.status);
              const formattedAmount = AccountSettingsStore.formatAmountText(
                item.amount,
                true
              );
              return (
                <FlexContainer
                  key={index}
                  spacing={30}
                  alignItems="center"
                  className="funding-labels"
                  onClick={() =>
                    navigate(
                      `/app/funding/detail/${item.merchantAccountId}/${item.payoutId}`
                    )
                  }
                >
                  <CustomLabel className="funding-date">
                    {UtilityMethods.formatDateInString(new Date(item.date))}
                  </CustomLabel>
                  <div>
                    <FlexContainer spacing={20} alignItems="center">
                      <CustomLabel className="funding-value">
                        {formattedAmount}
                      </CustomLabel>
                      <CustomButton bgColor={bgColor} color={textColor}>
                        <img src={icon} alt="" />
                        <CustomLabel color={textColor}>
                          {" "}
                          {item.status}
                        </CustomLabel>
                      </CustomButton>
                    </FlexContainer>
                  </div>
                </FlexContainer>
              );
            })}
          </FlexContainer>
        </div>
      </FlexContainer>
    );
  }

  const formattedBalance = AccountSettingsStore.formatAmountText(fundingWidgetData.balance, true)
  return (
    <FundingWidgetWrapper fxLayout="column" spacing={20}>
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper flex-unset"
      >
        <div>
          <FlexContainer alignItems="center" spacing={10}>
            <img src={FundingIcon} />
            <div className="activity-card-header"> Funding</div>
          </FlexContainer>
        </div>
        <div>
          <SapphireBlueButton onClick={() => navigate(`/app/funding`)}>
            View
          </SapphireBlueButton>
        </div>
      </FlexContainer>
      <FlexContainer fxLayout="column" spacing={20}>
        <CustomLabel>Balance (USD)</CustomLabel>
        <CustomLabel
          fontWeight={"600"}
          fontSize={"30px"}
          lineHeight="normal"
          margin="0px 0px 20px"
        >
          {
            formattedBalance
          }
        </CustomLabel>
      </FlexContainer>
      {payOutsSection()}
    </FundingWidgetWrapper>
  );
};
export default withRouter(FundingWidget);
